export default "__VITE_ASSET__Bszk6ZCg__"